import authEn from "./en.json";
import de from './de.json';

export default {
  en: authEn,
  de: de
};
